import React from 'react';
import { TextInputField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../../components';
import { DocumentInspectorProps } from '../../../types';
import { AnchorTargetProps } from './AnchorTarget';

export function AnchorTargetInspector({
  value,
  onChange,
}: DocumentInspectorProps<AnchorTargetProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent header="앵커 타겟 id">
        <TextInputField name="targetId" width="100%" />
      </FormContent>
    </InspectorFormProvider>
  );
}
